import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default {
    __name: 'Pagination',
    props: {
        pageSize: {
            type: Number,
            default: 1
        },
        total: {
            type: Number,
            default: 12
        },
        sizeChange: {
            type: Function,
            default: ()=>{}
        }
    },
    setup (__props) {
        return (_ctx, _cache)=>{
            const _component_el_pagination = _resolveComponent("el-pagination");
            return _openBlock(), _createBlock(_component_el_pagination, {
                "page-size": __props.pageSize,
                "pager-count": 5,
                layout: "prev, pager, next",
                total: __props.total,
                onSizeChange: __props.sizeChange,
                onCurrentChange: __props.sizeChange
            }, null, 8, [
                "page-size",
                "total",
                "onSizeChange",
                "onCurrentChange"
            ]);
        };
    }
};
